import { useHistory } from "react-router-dom"
import { Container } from "src/components/container"
import { Button } from "src/components/ui/button"
import { ChevronRight } from "src/icons"
import "./style.scss"

export const IBANJoin = () => {
  const history = useHistory()
  return (
    <div className="iban-join">
      <Container>
        <h1>Join to Best Banking Solution Today!</h1>
        <p>Open your account in minutes and experience seamless global payments!</p>
        <Button onClick={() => history.push("/register/corporate")} rightIcon={<ChevronRight />}>
          OPEN ACCOUNT
        </Button>
      </Container>
    </div>
  )
}
